import { NgComponentOutlet, CommonModule } from '@angular/common';
import { InjectionToken, Directive, Host, Renderer2, KeyValueDiffers, Injector, Type, Inject, Optional, Input, SimpleChange, ChangeDetectorRef, Injectable, ComponentFactoryResolver, EventEmitter, ViewContainerRef, IterableDiffers, Output, Component, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-injector.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
function ComponentInjector() { }
if (false) {
    /** @type {?} */
    ComponentInjector.prototype.componentRef;
}
/** @type {?} */
const COMPONENT_INJECTOR = new InjectionToken('ComponentInjector');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component-outlet-injector.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ComponentOutletInjectorDirective {
    /**
     * @param {?} componentOutlet
     */
    constructor(componentOutlet) {
        this.componentOutlet = componentOutlet;
    }
    /**
     * @return {?}
     */
    get componentRef() {
        return ((/** @type {?} */ (this.componentOutlet)))._componentRef;
    }
}
ComponentOutletInjectorDirective.ɵfac = function ComponentOutletInjectorDirective_Factory(t) { return new (t || ComponentOutletInjectorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgComponentOutlet, 1)); };
ComponentOutletInjectorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ComponentOutletInjectorDirective, selectors: [["", "ngComponentOutlet", ""]], exportAs: ["ndcComponentOutletInjector"] });
/** @nocollapse */
ComponentOutletInjectorDirective.ctorParameters = () => [
    { type: NgComponentOutlet, decorators: [{ type: Host }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ComponentOutletInjectorDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[ngComponentOutlet]',
                exportAs: 'ndcComponentOutletInjector'
            }]
    }], function () { return [{ type: ɵngcc1.NgComponentOutlet, decorators: [{
                type: Host
            }] }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    ComponentOutletInjectorDirective.prototype.componentOutlet;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-attributes.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function AttributesMap() { }
/**
 * @record
 */
function AttributeActions() { }
if (false) {
    /** @type {?} */
    AttributeActions.prototype.set;
    /** @type {?} */
    AttributeActions.prototype.remove;
}
class DynamicAttributesDirective {
    /**
     * @param {?} renderer
     * @param {?} differs
     * @param {?} injector
     * @param {?} componentInjectorType
     * @param {?} componentOutletInjector
     */
    constructor(renderer, differs, injector, componentInjectorType, componentOutletInjector) {
        this.renderer = renderer;
        this.differs = differs;
        this.injector = injector;
        this.componentInjectorType = componentInjectorType;
        this.componentOutletInjector = componentOutletInjector;
        this.attrsDiffer = this.differs.find({}).create();
        this.componentInjector = this.injector.get(this.componentInjectorType, null);
    }
    /**
     * @private
     * @return {?}
     */
    get _attributes() {
        return (this.ndcDynamicAttributes || this.ngComponentOutletNdcDynamicAttributes);
    }
    /**
     * @private
     * @return {?}
     */
    get _compInjector() {
        return this.componentOutletInjector || this.componentInjector;
    }
    /**
     * @private
     * @return {?}
     */
    get _nativeElement() {
        return (this._compInjector.componentRef &&
            this._compInjector.componentRef.location.nativeElement);
    }
    /**
     * @private
     * @return {?}
     */
    get _compType() {
        return (this._compInjector.componentRef &&
            this._compInjector.componentRef.componentType);
    }
    /**
     * @private
     * @return {?}
     */
    get _isCompChanged() {
        if (this.lastCompType !== this._compType) {
            this.lastCompType = this._compType;
            return true;
        }
        return false;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        /** @type {?} */
        const isCompChanged = this._isCompChanged;
        /** @type {?} */
        const changes = this.attrsDiffer.diff(this._attributes);
        if (changes) {
            this.lastAttrActions = this._changesToAttrActions(changes);
        }
        if (changes || (isCompChanged && this.lastAttrActions)) {
            this._updateAttributes(this.lastAttrActions);
        }
    }
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    setAttribute(name, value, namespace) {
        if (this._nativeElement) {
            this.renderer.setAttribute(this._nativeElement, name, value, namespace);
        }
    }
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    removeAttribute(name, namespace) {
        if (this._nativeElement) {
            this.renderer.removeAttribute(this._nativeElement, name, namespace);
        }
    }
    /**
     * @private
     * @param {?} actions
     * @return {?}
     */
    _updateAttributes(actions) {
        // ? Early exit if no dynamic component
        if (!this._compType) {
            return;
        }
        Object.keys(actions.set).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => this.setAttribute(key, actions.set[key])));
        actions.remove.forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => this.removeAttribute(key)));
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    _changesToAttrActions(changes) {
        /** @type {?} */
        const attrActions = {
            set: {},
            remove: [],
        };
        changes.forEachAddedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => (attrActions.set[r.key] = r.currentValue)));
        changes.forEachChangedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => (attrActions.set[r.key] = r.currentValue)));
        changes.forEachRemovedItem((/**
         * @param {?} r
         * @return {?}
         */
        r => attrActions.remove.push(r.key)));
        return attrActions;
    }
}
DynamicAttributesDirective.ɵfac = function DynamicAttributesDirective_Factory(t) { return new (t || DynamicAttributesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(COMPONENT_INJECTOR), ɵngcc0.ɵɵdirectiveInject(ComponentOutletInjectorDirective, 9)); };
DynamicAttributesDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DynamicAttributesDirective, selectors: [["", "ndcDynamicAttributes", ""], ["", "ngComponentOutletNdcDynamicAttributes", ""]], inputs: { ndcDynamicAttributes: "ndcDynamicAttributes", ngComponentOutletNdcDynamicAttributes: "ngComponentOutletNdcDynamicAttributes" }, exportAs: ["ndcDynamicAttributes"] });
/** @nocollapse */
DynamicAttributesDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: KeyValueDiffers },
    { type: Injector },
    { type: Type, decorators: [{ type: Inject, args: [COMPONENT_INJECTOR,] }] },
    { type: ComponentOutletInjectorDirective, decorators: [{ type: Optional }, { type: Host }] }
];
DynamicAttributesDirective.propDecorators = {
    ndcDynamicAttributes: [{ type: Input }],
    ngComponentOutletNdcDynamicAttributes: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicAttributesDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicAttributes],[ngComponentOutletNdcDynamicAttributes]',
                exportAs: 'ndcDynamicAttributes'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.Injector }, { type: ɵngcc0.Type, decorators: [{
                type: Inject,
                args: [COMPONENT_INJECTOR]
            }] }, { type: ComponentOutletInjectorDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, { ndcDynamicAttributes: [{
            type: Input
        }], ngComponentOutletNdcDynamicAttributes: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicAttributesDirective.prototype.ndcDynamicAttributes;
    /** @type {?} */
    DynamicAttributesDirective.prototype.ngComponentOutletNdcDynamicAttributes;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.attrsDiffer;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.componentInjector;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.lastCompType;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.lastAttrActions;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.renderer;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.componentInjectorType;
    /**
     * @type {?}
     * @private
     */
    DynamicAttributesDirective.prototype.componentOutletInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/util.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} val
 * @return {?}
 */
function createNewChange(val) {
    return new SimpleChange(undefined, val, true);
}
/**
 * @param {?} record
 * @param {?=} isFirstChange
 * @return {?}
 */
function recordToChange(record, isFirstChange = false) {
    return isFirstChange
        ? createNewChange(record.currentValue)
        : new SimpleChange(record.previousValue, record.currentValue, false);
}
/**
 * @param {?} isFirstChanges
 * @param {?} setter
 * @return {?}
 */
function setChangeFromRecord(isFirstChanges, setter) {
    return (/**
     * @param {?} record
     * @return {?}
     */
    (record) => setter(record, recordToChange(record, isFirstChanges)));
}
/**
 * @param {?} isFirstChanges
 * @return {?}
 */
function getChangesRecords(isFirstChanges) {
    return (/**
     * @param {?} changes
     * @return {?}
     */
    (changes) => setChangeFromRecord(isFirstChanges, (/**
     * @param {?} record
     * @param {?} change
     * @return {?}
     */
    (record, change) => (changes[record.key] = change))));
}
/**
 * @param {?} isFirstChanges
 * @return {?}
 */
function getNewChangesRecords(isFirstChanges) {
    return (/**
     * @param {?} changes
     * @return {?}
     */
    (changes) => setChangeFromRecord(isFirstChanges, (/**
     * @param {?} record
     * @param {?} change
     * @return {?}
     */
    (record, change) => {
        if (!changes[record.key]) {
            changes[record.key] = change;
        }
    })));
}
/** @type {?} */
const defaultOpts = {
    isFirstChanges: false,
    onlyNewChanges: false,
};
/**
 * @param {?=} opts
 * @return {?}
 */
function changesFromRecord(opts = defaultOpts) {
    return opts.onlyNewChanges
        ? getNewChangesRecords(opts.isFirstChanges)
        : getChangesRecords(opts.isFirstChanges);
}
/**
 * @return {?}
 */
function noop() { }
/**
 * @param {?} ctor
 * @param {?} reflect
 * @return {?}
 */
function getCtorType(ctor, reflect) {
    return reflect.getMetadata('design:paramtypes', ctor);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function InputsType() { }
/**
 * @record
 */
function OutputsType() { }
/**
 * @record
 */
function IOMapInfo() { }
if (false) {
    /** @type {?} */
    IOMapInfo.prototype.propName;
    /** @type {?} */
    IOMapInfo.prototype.templateName;
}
/**
 * @record
 */
function IoInitOptions() { }
if (false) {
    /** @type {?|undefined} */
    IoInitOptions.prototype.trackOutputChanges;
}
/** @type {?} */
const recordToChanges = changesFromRecord({ isFirstChanges: true });
/** @type {?} */
const recordToNewChanges = changesFromRecord({ onlyNewChanges: true });
class IoService {
    /**
     * @param {?} differs
     * @param {?} cfr
     */
    constructor(differs, cfr) {
        this.differs = differs;
        this.cfr = cfr;
        this.checkInit = this.failInit;
        this.lastComponentInst = null;
        this.inputsDiffer = this.differs.find({}).create();
        this.compFactory = null;
        this.outputsShouldDisconnect$ = new Subject();
        this.outputsChanged = (/**
         * @return {?}
         */
        () => false);
    }
    /**
     * @private
     * @return {?}
     */
    get compRef() {
        return this.compInjector.componentRef;
    }
    /**
     * @private
     * @return {?}
     */
    get componentInst() {
        return this.compRef ? this.compRef.instance : null;
    }
    /**
     * @private
     * @return {?}
     */
    get componentInstChanged() {
        if (this.lastComponentInst !== this.componentInst) {
            this.lastComponentInst = this.componentInst;
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * @private
     * @return {?}
     */
    get compCdr() {
        // tslint:disable-next-line: deprecation
        return this.compRef ? this.compRef.injector.get(ChangeDetectorRef) : null;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._disconnectOutputs();
    }
    /**
     * @param {?} componentInjector
     * @param {?=} options
     * @return {?}
     */
    init(componentInjector, options = {}) {
        this.checkInit = componentInjector ? noop : this.failInit;
        this.compInjector = componentInjector;
        if (options.trackOutputChanges) {
            /** @type {?} */
            const outputsDiffer = this.differs.find({}).create();
            this.outputsChanged = (/**
             * @param {?} outputs
             * @return {?}
             */
            outputs => !!outputsDiffer.diff(outputs));
        }
    }
    /**
     * @param {?} inputs
     * @param {?} outputs
     * @param {?} inputsChanged
     * @param {?} outputsChanged
     * @return {?}
     */
    update(inputs, outputs, inputsChanged, outputsChanged) {
        this.checkInit();
        this.updateIO(inputs, outputs);
        /** @type {?} */
        const compChanged = this.componentInstChanged;
        if (compChanged || inputsChanged) {
            /** @type {?} */
            const inputsChanges = this._getInputsChanges(this.inputs);
            if (inputsChanges) {
                this._updateInputChanges(inputsChanges);
            }
            this.updateInputs(compChanged || !this.lastInputChanges);
        }
        if (compChanged || outputsChanged) {
            this.bindOutputs();
        }
    }
    /**
     * @return {?}
     */
    maybeUpdate() {
        this.checkInit();
        if (this.componentInstChanged) {
            this.updateInputs(true);
            this.bindOutputs();
            return;
        }
        if (this.outputsChanged(this.outputs)) {
            this.bindOutputs();
        }
        if (!this.inputs) {
            return;
        }
        /** @type {?} */
        const inputsChanges = this._getInputsChanges(this.inputs);
        if (inputsChanges) {
            /** @type {?} */
            const isNotFirstChange = !!this.lastInputChanges;
            this._updateInputChanges(inputsChanges);
            if (isNotFirstChange) {
                this.updateInputs();
            }
        }
    }
    /**
     * @private
     * @param {?} inputs
     * @param {?} outputs
     * @return {?}
     */
    updateIO(inputs, outputs) {
        this.inputs = inputs;
        this.outputs = outputs;
    }
    /**
     * @private
     * @param {?=} isFirstChange
     * @return {?}
     */
    updateInputs(isFirstChange = false) {
        if (isFirstChange) {
            this._updateCompFactory();
        }
        /** @type {?} */
        const compInst = this.componentInst;
        /** @type {?} */
        let inputs = this.inputs;
        if (!inputs || !compInst) {
            return;
        }
        inputs = this._resolveInputs(inputs);
        Object.keys(inputs).forEach((/**
         * @param {?} p
         * @return {?}
         */
        p => (compInst[p] = inputs[p])));
        // Mark component for check to re-render with new inputs
        if (this.compCdr) {
            this.compCdr.markForCheck();
        }
        this.notifyOnInputChanges(this.lastInputChanges, isFirstChange);
    }
    /**
     * @private
     * @return {?}
     */
    bindOutputs() {
        this._disconnectOutputs();
        /** @type {?} */
        const compInst = this.componentInst;
        /** @type {?} */
        let outputs = this.outputs;
        if (!outputs || !compInst) {
            return;
        }
        outputs = this._resolveOutputs(outputs);
        Object.keys(outputs)
            .filter((/**
         * @param {?} p
         * @return {?}
         */
        p => compInst[p]))
            .forEach((/**
         * @param {?} p
         * @return {?}
         */
        p => compInst[p]
            .pipe(takeUntil(this.outputsShouldDisconnect$))
            .subscribe(outputs[p])));
    }
    /**
     * @private
     * @param {?=} changes
     * @param {?=} forceFirstChanges
     * @return {?}
     */
    notifyOnInputChanges(changes = {}, forceFirstChanges) {
        // Exit early if component not interested to receive changes
        if (!this.componentInst.ngOnChanges) {
            return;
        }
        if (forceFirstChanges) {
            changes = this._collectFirstChanges();
        }
        this.componentInst.ngOnChanges(changes);
    }
    /**
     * @private
     * @return {?}
     */
    _disconnectOutputs() {
        this.outputsShouldDisconnect$.next();
    }
    /**
     * @private
     * @param {?} inputs
     * @return {?}
     */
    _getInputsChanges(inputs) {
        return this.inputsDiffer.diff(this.inputs);
    }
    /**
     * @private
     * @param {?} differ
     * @return {?}
     */
    _updateInputChanges(differ) {
        this.lastInputChanges = this._collectChangesFromDiffer(differ);
    }
    /**
     * @private
     * @return {?}
     */
    _collectFirstChanges() {
        /** @type {?} */
        const changes = (/** @type {?} */ ({}));
        /** @type {?} */
        const inputs = this.inputs;
        Object.keys(inputs).forEach((/**
         * @param {?} prop
         * @return {?}
         */
        prop => (changes[prop] = createNewChange(inputs[prop]))));
        return this._resolveChanges(changes);
    }
    /**
     * @private
     * @param {?} differ
     * @return {?}
     */
    _collectChangesFromDiffer(differ) {
        /** @type {?} */
        const changes = (/** @type {?} */ ({}));
        differ.forEachAddedItem(recordToChanges(changes));
        differ.forEachItem(recordToNewChanges(changes));
        return this._resolveChanges(changes);
    }
    /**
     * @private
     * @return {?}
     */
    _resolveCompFactory() {
        try {
            try {
                return this.cfr.resolveComponentFactory(this.compRef.componentType);
            }
            catch (e) {
                // Fallback if componentType does not exist (happens on NgComponentOutlet)
                return this.cfr.resolveComponentFactory(this.compRef.instance.constructor);
            }
        }
        catch (e) {
            // Factory not available - bailout
            return null;
        }
    }
    /**
     * @private
     * @return {?}
     */
    _updateCompFactory() {
        this.compFactory = this._resolveCompFactory();
    }
    /**
     * @private
     * @param {?} inputs
     * @return {?}
     */
    _resolveInputs(inputs) {
        if (!this.compFactory) {
            return inputs;
        }
        return this._remapIO(inputs, this.compFactory.inputs);
    }
    /**
     * @private
     * @param {?} outputs
     * @return {?}
     */
    _resolveOutputs(outputs) {
        if (!this.compFactory) {
            return outputs;
        }
        return this._remapIO(outputs, this.compFactory.outputs);
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    _resolveChanges(changes) {
        if (!this.compFactory) {
            return changes;
        }
        return this._remapIO(changes, this.compFactory.inputs);
    }
    /**
     * @private
     * @param {?} io
     * @param {?} mapping
     * @return {?}
     */
    _remapIO(io, mapping) {
        /** @type {?} */
        const newIO = {};
        Object.keys(io).forEach((/**
         * @param {?} key
         * @return {?}
         */
        key => {
            /** @type {?} */
            const newKey = this._findPropByTplInMapping(key, mapping) || key;
            newIO[newKey] = io[key];
        }));
        return newIO;
    }
    /**
     * @private
     * @param {?} tplName
     * @param {?} mapping
     * @return {?}
     */
    _findPropByTplInMapping(tplName, mapping) {
        for (const map of mapping) {
            if (map.templateName === tplName) {
                return map.propName;
            }
        }
        return null;
    }
    /**
     * @private
     * @return {?}
     */
    failInit() {
        throw Error('IoService: ComponentInjector was not set! Please call init() method!');
    }
}
IoService.ɵfac = function IoService_Factory(t) { return new (t || IoService)(ɵngcc0.ɵɵinject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver)); };
IoService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: IoService, factory: IoService.ɵfac });
/** @nocollapse */
IoService.ctorParameters = () => [
    { type: KeyValueDiffers },
    { type: ComponentFactoryResolver }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IoService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.ComponentFactoryResolver }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.checkInit;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.lastComponentInst;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.lastInputChanges;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.inputsDiffer;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.compFactory;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputsShouldDisconnect$;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.inputs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.compInjector;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.outputsChanged;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    IoService.prototype.cfr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/io-factory.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IoFactoryService {
    /**
     * @param {?} differs
     * @param {?} cfr
     */
    constructor(differs, cfr) {
        this.differs = differs;
        this.cfr = cfr;
    }
    /**
     * @return {?}
     */
    create() {
        return new IoService(this.differs, this.cfr);
    }
}
IoFactoryService.ɵfac = function IoFactoryService_Factory(t) { return new (t || IoFactoryService)(ɵngcc0.ɵɵinject(ɵngcc0.KeyValueDiffers), ɵngcc0.ɵɵinject(ɵngcc0.ComponentFactoryResolver)); };
IoFactoryService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: IoFactoryService, factory: IoFactoryService.ɵfac });
/** @nocollapse */
IoFactoryService.ctorParameters = () => [
    { type: KeyValueDiffers },
    { type: ComponentFactoryResolver }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(IoFactoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.KeyValueDiffers }, { type: ɵngcc0.ComponentFactoryResolver }]; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.differs;
    /**
     * @type {?}
     * @private
     */
    IoFactoryService.prototype.cfr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/window-ref.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const WINDOW_REF = new InjectionToken('WindowRef');
class WindowRefService {
    /**
     * @param {?} injector
     */
    constructor(injector) {
        this.injector = injector;
        this.nativeWindow = this.injector.get(WINDOW_REF, null);
    }
}
WindowRefService.ɵfac = function WindowRefService_Factory(t) { return new (t || WindowRefService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
WindowRefService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WindowRefService, factory: WindowRefService.ɵfac });
/** @nocollapse */
WindowRefService.ctorParameters = () => [
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WindowRefService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
if (false) {
    /** @type {?} */
    WindowRefService.prototype.nativeWindow;
    /**
     * @type {?}
     * @private
     */
    WindowRefService.prototype.injector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic-directives.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 * @template T
 */
function DynamicDirectiveDef() { }
if (false) {
    /** @type {?} */
    DynamicDirectiveDef.prototype.type;
    /** @type {?|undefined} */
    DynamicDirectiveDef.prototype.inputs;
    /** @type {?|undefined} */
    DynamicDirectiveDef.prototype.outputs;
}
/**
 * @template T
 * @param {?} type
 * @param {?=} inputs
 * @param {?=} outputs
 * @return {?}
 */
function dynamicDirectiveDef(type, inputs, outputs) {
    return { type, inputs, outputs };
}
/**
 * @record
 * @template T
 */
function DirectiveRef() { }
if (false) {
    /** @type {?} */
    DirectiveRef.prototype.instance;
    /** @type {?} */
    DirectiveRef.prototype.type;
    /** @type {?} */
    DirectiveRef.prototype.injector;
    /** @type {?} */
    DirectiveRef.prototype.hostComponent;
    /** @type {?} */
    DirectiveRef.prototype.hostView;
    /** @type {?} */
    DirectiveRef.prototype.location;
    /** @type {?} */
    DirectiveRef.prototype.changeDetectorRef;
    /** @type {?} */
    DirectiveRef.prototype.onDestroy;
}
class DynamicDirectivesDirective {
    /**
     * @param {?} injector
     * @param {?} iterableDiffers
     * @param {?} ioFactoryService
     * @param {?} windowRef
     * @param {?} componentInjectorType
     * @param {?} componentOutletInjector
     */
    constructor(injector, iterableDiffers, ioFactoryService, windowRef, componentInjectorType, componentOutletInjector) {
        this.injector = injector;
        this.iterableDiffers = iterableDiffers;
        this.ioFactoryService = ioFactoryService;
        this.windowRef = windowRef;
        this.componentInjectorType = componentInjectorType;
        this.componentOutletInjector = componentOutletInjector;
        this.ndcDynamicDirectivesCreated = new EventEmitter();
        this.componentInjector = this.injector.get(this.componentInjectorType, null);
        this.dirRef = new Map();
        this.dirIo = new Map();
        this.dirsDiffer = this.iterableDiffers
            .find([])
            .create((/**
         * @param {?} _
         * @param {?} def
         * @return {?}
         */
        (_, def) => def.type));
    }
    /**
     * @private
     * @return {?}
     */
    get directives() {
        return (this.ndcDynamicDirectives || this.ngComponentOutletNdcDynamicDirectives);
    }
    /**
     * @private
     * @return {?}
     */
    get compInjector() {
        return this.componentOutletInjector || this.componentInjector;
    }
    /**
     * @private
     * @return {?}
     */
    get componentRef() {
        return this.compInjector.componentRef;
    }
    /**
     * @private
     * @return {?}
     */
    get compInstance() {
        return this.componentRef && this.componentRef.instance;
    }
    /**
     * @private
     * @return {?}
     */
    get isCompChanged() {
        if (this.lastCompInstance !== this.compInstance) {
            this.lastCompInstance = this.compInstance;
            return true;
        }
        return false;
    }
    /**
     * @private
     * @return {?}
     */
    get hostInjector() {
        return this.componentRef.injector;
    }
    /**
     * @private
     * @return {?}
     */
    get hostVcr() {
        // NOTE: Accessing private APIs of Angular
        // tslint:disable-next-line: no-string-literal
        return this.componentRef['_viewRef']['_viewContainerRef'];
    }
    /**
     * @private
     * @return {?}
     */
    get reflect() {
        return ((/** @type {?} */ (this.windowRef.nativeWindow))).Reflect;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        if (this.maybeDestroyDirectives()) {
            return;
        }
        /** @type {?} */
        const dirsChanges = this.dirsDiffer.diff(this.directives);
        if (!dirsChanges) {
            return this.updateDirectives();
        }
        this.processDirChanges(dirsChanges);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.destroyAllDirectives();
    }
    /**
     * @private
     * @return {?}
     */
    maybeDestroyDirectives() {
        if (this.isCompChanged || !this.componentRef) {
            this.dirsDiffer.diff([]);
            this.destroyAllDirectives();
        }
        return !this.componentRef;
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    processDirChanges(changes) {
        changes.forEachRemovedItem((/**
         * @param {?} __0
         * @return {?}
         */
        ({ item }) => this.destroyDirective(item)));
        /** @type {?} */
        const createdDirs = [];
        changes.forEachAddedItem((/**
         * @param {?} __0
         * @return {?}
         */
        ({ item }) => createdDirs.push(this.initDirective(item))));
        if (createdDirs.length) {
            this.ndcDynamicDirectivesCreated.emit(createdDirs.filter(Boolean));
        }
    }
    /**
     * @private
     * @return {?}
     */
    updateDirectives() {
        this.directives.forEach((/**
         * @param {?} dir
         * @return {?}
         */
        dir => this.updateDirective(dir)));
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    updateDirective(dirDef) {
        /** @type {?} */
        const io = this.dirIo.get(dirDef.type);
        io.update(dirDef.inputs, dirDef.outputs, false, false);
        io.maybeUpdate();
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    initDirective(dirDef) {
        if (this.dirRef.has(dirDef.type)) {
            return;
        }
        /** @type {?} */
        const instance = this.createDirective(dirDef.type);
        /** @type {?} */
        const dir = {
            instance,
            type: dirDef.type,
            injector: this.hostInjector,
            hostComponent: this.componentRef.instance,
            hostView: this.componentRef.hostView,
            location: this.componentRef.location,
            changeDetectorRef: this.componentRef.changeDetectorRef,
            onDestroy: this.componentRef.onDestroy,
        };
        this.initDirIO(dir, dirDef.inputs, dirDef.outputs);
        this.callInitHooks(instance);
        this.dirRef.set(dir.type, dir);
        return dir;
    }
    /**
     * @private
     * @return {?}
     */
    destroyAllDirectives() {
        this.dirRef.forEach((/**
         * @param {?} dir
         * @return {?}
         */
        dir => this.destroyDirRef(dir)));
        this.dirRef.clear();
        this.dirIo.clear();
    }
    /**
     * @private
     * @param {?} dirDef
     * @return {?}
     */
    destroyDirective(dirDef) {
        this.destroyDirRef(this.dirRef.get(dirDef.type));
        this.dirRef.delete(dirDef.type);
        this.dirIo.delete(dirDef.type);
    }
    /**
     * @private
     * @param {?} dir
     * @param {?=} inputs
     * @param {?=} outputs
     * @return {?}
     */
    initDirIO(dir, inputs, outputs) {
        /** @type {?} */
        const io = this.ioFactoryService.create();
        io.init({ componentRef: this.dirToCompDef(dir) }, { trackOutputChanges: true });
        io.update(inputs, outputs, !!inputs, !!outputs);
        this.dirIo.set(dir.type, io);
    }
    /**
     * @private
     * @param {?} dir
     * @return {?}
     */
    dirToCompDef(dir) {
        return {
            changeDetectorRef: this.componentRef.changeDetectorRef,
            hostView: this.componentRef.hostView,
            location: this.componentRef.location,
            destroy: this.componentRef.destroy,
            onDestroy: this.componentRef.onDestroy,
            injector: this.componentRef.injector,
            instance: dir.instance,
            componentType: dir.type,
        };
    }
    /**
     * @private
     * @param {?} dir
     * @return {?}
     */
    destroyDirRef(dir) {
        /** @type {?} */
        const io = this.dirIo.get(dir.type);
        io.ngOnDestroy();
        if ('ngOnDestroy' in dir.instance) {
            dir.instance.ngOnDestroy();
        }
    }
    /**
     * @private
     * @template T
     * @param {?} dirType
     * @return {?}
     */
    createDirective(dirType) {
        /** @type {?} */
        const ctorParams = getCtorType(dirType, this.reflect);
        /** @type {?} */
        const resolvedParams = ctorParams.map((/**
         * @param {?} p
         * @return {?}
         */
        p => this.resolveDep(p)));
        return new dirType(...resolvedParams);
    }
    /**
     * @private
     * @param {?} dep
     * @return {?}
     */
    resolveDep(dep) {
        // tslint:disable-next-line: deprecation
        return this.maybeResolveVCR(dep) || this.hostInjector.get(dep);
    }
    /**
     * @private
     * @param {?} dep
     * @return {?}
     */
    maybeResolveVCR(dep) {
        if (dep === ViewContainerRef) {
            return this.hostVcr;
        }
    }
    /**
     * @private
     * @param {?} obj
     * @return {?}
     */
    callInitHooks(obj) {
        this.callHook(obj, 'ngOnInit');
        this.callHook(obj, 'ngDoCheck');
        this.callHook(obj, 'ngAfterContentInit');
        this.callHook(obj, 'ngAfterContentChecked');
        this.callHook(obj, 'ngAfterViewInit');
        this.callHook(obj, 'ngAfterViewChecked');
    }
    /**
     * @private
     * @param {?} obj
     * @param {?} hook
     * @param {?=} args
     * @return {?}
     */
    callHook(obj, hook, args = []) {
        if (obj[hook]) {
            obj[hook](...args);
        }
    }
}
DynamicDirectivesDirective.ɵfac = function DynamicDirectivesDirective_Factory(t) { return new (t || DynamicDirectivesDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.IterableDiffers), ɵngcc0.ɵɵdirectiveInject(IoFactoryService), ɵngcc0.ɵɵdirectiveInject(WindowRefService), ɵngcc0.ɵɵdirectiveInject(COMPONENT_INJECTOR), ɵngcc0.ɵɵdirectiveInject(ComponentOutletInjectorDirective, 9)); };
DynamicDirectivesDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DynamicDirectivesDirective, selectors: [["", "ndcDynamicDirectives", ""], ["", "ngComponentOutletNdcDynamicDirectives", ""]], inputs: { ndcDynamicDirectives: "ndcDynamicDirectives", ngComponentOutletNdcDynamicDirectives: "ngComponentOutletNdcDynamicDirectives" }, outputs: { ndcDynamicDirectivesCreated: "ndcDynamicDirectivesCreated" } });
/** @nocollapse */
DynamicDirectivesDirective.ctorParameters = () => [
    { type: Injector },
    { type: IterableDiffers },
    { type: IoFactoryService },
    { type: WindowRefService },
    { type: Type, decorators: [{ type: Inject, args: [COMPONENT_INJECTOR,] }] },
    { type: ComponentOutletInjectorDirective, decorators: [{ type: Host }, { type: Optional }] }
];
DynamicDirectivesDirective.propDecorators = {
    ndcDynamicDirectives: [{ type: Input }],
    ngComponentOutletNdcDynamicDirectives: [{ type: Input }],
    ndcDynamicDirectivesCreated: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicDirectivesDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicDirectives],[ngComponentOutletNdcDynamicDirectives]'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.IterableDiffers }, { type: IoFactoryService }, { type: WindowRefService }, { type: ɵngcc0.Type, decorators: [{
                type: Inject,
                args: [COMPONENT_INJECTOR]
            }] }, { type: ComponentOutletInjectorDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }]; }, { ndcDynamicDirectivesCreated: [{
            type: Output
        }], ndcDynamicDirectives: [{
            type: Input
        }], ngComponentOutletNdcDynamicDirectives: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ndcDynamicDirectives;
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ngComponentOutletNdcDynamicDirectives;
    /** @type {?} */
    DynamicDirectivesDirective.prototype.ndcDynamicDirectivesCreated;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.componentInjector;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.lastCompInstance;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirRef;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirIo;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.dirsDiffer;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.iterableDiffers;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.ioFactoryService;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.windowRef;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.componentInjectorType;
    /**
     * @type {?}
     * @private
     */
    DynamicDirectivesDirective.prototype.componentOutletInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DynamicComponent {
    /**
     * @param {?} vcr
     * @param {?} cfr
     */
    constructor(vcr, cfr) {
        this.vcr = vcr;
        this.cfr = cfr;
        this.ndcDynamicCreated = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.ndcDynamicComponent) {
            this.createDynamicComponent();
        }
    }
    /**
     * @return {?}
     */
    createDynamicComponent() {
        this.vcr.clear();
        this.componentRef = null;
        if (this.ndcDynamicComponent) {
            this.componentRef = this.vcr.createComponent(this.cfr.resolveComponentFactory(this.ndcDynamicComponent), 0, this._resolveInjector(), this.ndcDynamicContent);
            this.ndcDynamicCreated.emit(this.componentRef);
        }
    }
    /**
     * @private
     * @return {?}
     */
    _resolveInjector() {
        /** @type {?} */
        let injector = this.ndcDynamicInjector || this.vcr.injector;
        if (this.ndcDynamicProviders) {
            injector = Injector.create({
                providers: this.ndcDynamicProviders,
                parent: injector,
            });
        }
        return injector;
    }
}
DynamicComponent.ɵfac = function DynamicComponent_Factory(t) { return new (t || DynamicComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
DynamicComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicComponent, selectors: [["ndc-dynamic"]], inputs: { ndcDynamicComponent: "ndcDynamicComponent", ndcDynamicInjector: "ndcDynamicInjector", ndcDynamicProviders: "ndcDynamicProviders", ndcDynamicContent: "ndcDynamicContent" }, outputs: { ndcDynamicCreated: "ndcDynamicCreated" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function DynamicComponent_Template(rf, ctx) { }, encapsulation: 2 });
/** @nocollapse */
DynamicComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
DynamicComponent.propDecorators = {
    ndcDynamicComponent: [{ type: Input }],
    ndcDynamicInjector: [{ type: Input }],
    ndcDynamicProviders: [{ type: Input }],
    ndcDynamicContent: [{ type: Input }],
    ndcDynamicCreated: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicComponent, [{
        type: Component,
        args: [{
                selector: 'ndc-dynamic',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { ndcDynamicCreated: [{
            type: Output
        }], ndcDynamicComponent: [{
            type: Input
        }], ndcDynamicInjector: [{
            type: Input
        }], ndcDynamicProviders: [{
            type: Input
        }], ndcDynamicContent: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicComponent;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicInjector;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicProviders;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicContent;
    /** @type {?} */
    DynamicComponent.prototype.ndcDynamicCreated;
    /** @type {?} */
    DynamicComponent.prototype.componentRef;
    /**
     * @type {?}
     * @private
     */
    DynamicComponent.prototype.vcr;
    /**
     * @type {?}
     * @private
     */
    DynamicComponent.prototype.cfr;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// tslint:disable-next-line: no-conflicting-lifecycle
class DynamicDirective {
    /**
     * @param {?} injector
     * @param {?} ioService
     * @param {?} componentInjectorType
     * @param {?} componentOutletInjector
     */
    constructor(injector, ioService, componentInjectorType, componentOutletInjector) {
        this.injector = injector;
        this.ioService = ioService;
        this.componentInjectorType = componentInjectorType;
        this.componentOutletInjector = componentOutletInjector;
        this.componentInjector = this.injector.get(this.componentInjectorType, null);
        this.ioService.init(this.compInjector);
    }
    /**
     * @private
     * @return {?}
     */
    get inputs() {
        return this.ndcDynamicInputs || this.ngComponentOutletNdcDynamicInputs;
    }
    /**
     * @private
     * @return {?}
     */
    get outputs() {
        return this.ndcDynamicOutputs || this.ngComponentOutletNdcDynamicOutputs;
    }
    /**
     * @private
     * @return {?}
     */
    get compInjector() {
        return this.componentOutletInjector || this.componentInjector;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        this.ioService.update(this.inputs, this.outputs, this.inputsChanged(changes), this.outputsChanged(changes));
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        this.ioService.maybeUpdate();
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    inputsChanged(changes) {
        return ('ngComponentOutletNdcDynamicInputs' in changes ||
            'ndcDynamicInputs' in changes);
    }
    /**
     * @private
     * @param {?} changes
     * @return {?}
     */
    outputsChanged(changes) {
        return ('ngComponentOutletNdcDynamicOutputs' in changes ||
            'ndcDynamicOutputs' in changes);
    }
}
DynamicDirective.ɵfac = function DynamicDirective_Factory(t) { return new (t || DynamicDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(IoService), ɵngcc0.ɵɵdirectiveInject(COMPONENT_INJECTOR), ɵngcc0.ɵɵdirectiveInject(ComponentOutletInjectorDirective, 9)); };
DynamicDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DynamicDirective, selectors: [["", "ndcDynamicInputs", ""], ["", "ndcDynamicOutputs", ""], ["", "ngComponentOutletNdcDynamicInputs", ""], ["", "ngComponentOutletNdcDynamicOutputs", ""]], inputs: { ndcDynamicInputs: "ndcDynamicInputs", ngComponentOutletNdcDynamicInputs: "ngComponentOutletNdcDynamicInputs", ndcDynamicOutputs: "ndcDynamicOutputs", ngComponentOutletNdcDynamicOutputs: "ngComponentOutletNdcDynamicOutputs" }, features: [ɵngcc0.ɵɵProvidersFeature([IoService]), ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
DynamicDirective.ctorParameters = () => [
    { type: Injector },
    { type: IoService },
    { type: Type, decorators: [{ type: Inject, args: [COMPONENT_INJECTOR,] }] },
    { type: ComponentOutletInjectorDirective, decorators: [{ type: Host }, { type: Optional }] }
];
DynamicDirective.propDecorators = {
    ndcDynamicInputs: [{ type: Input }],
    ngComponentOutletNdcDynamicInputs: [{ type: Input }],
    ndcDynamicOutputs: [{ type: Input }],
    ngComponentOutletNdcDynamicOutputs: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicDirective, [{
        type: Directive,
        args: [{
                selector: '[ndcDynamicInputs],[ndcDynamicOutputs],[ngComponentOutletNdcDynamicInputs],[ngComponentOutletNdcDynamicOutputs]',
                providers: [IoService]
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: IoService }, { type: ɵngcc0.Type, decorators: [{
                type: Inject,
                args: [COMPONENT_INJECTOR]
            }] }, { type: ComponentOutletInjectorDirective, decorators: [{
                type: Host
            }, {
                type: Optional
            }] }]; }, { ndcDynamicInputs: [{
            type: Input
        }], ngComponentOutletNdcDynamicInputs: [{
            type: Input
        }], ndcDynamicOutputs: [{
            type: Input
        }], ngComponentOutletNdcDynamicOutputs: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    DynamicDirective.prototype.ndcDynamicInputs;
    /** @type {?} */
    DynamicDirective.prototype.ngComponentOutletNdcDynamicInputs;
    /** @type {?} */
    DynamicDirective.prototype.ndcDynamicOutputs;
    /** @type {?} */
    DynamicDirective.prototype.ngComponentOutletNdcDynamicOutputs;
    /**
     * @type {?}
     * @private
     */
    DynamicDirective.prototype.componentInjector;
    /**
     * @type {?}
     * @private
     */
    DynamicDirective.prototype.injector;
    /**
     * @type {?}
     * @private
     */
    DynamicDirective.prototype.ioService;
    /**
     * @type {?}
     * @private
     */
    DynamicDirective.prototype.componentInjectorType;
    /**
     * @type {?}
     * @private
     */
    DynamicDirective.prototype.componentOutletInjector;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/dynamic.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @return {?}
 */
function windowRefFactory() {
    return window;
}
class DynamicModule {
    /**
     * @param {?=} componentInjector
     * @return {?}
     */
    static forRoot(componentInjector = DynamicComponent) {
        return {
            ngModule: DynamicModule,
            providers: [
                { provide: COMPONENT_INJECTOR, useValue: componentInjector },
                IoFactoryService,
                { provide: WINDOW_REF, useFactory: windowRefFactory },
                WindowRefService,
            ],
        };
    }
    /**
     * @deprecated Since v6.0.0 - Passing a list of components is no longer required. Use `DynamicModule.forRoot()` instead.
     * @param {?} components
     * @param {?=} componentInjector
     * @return {?}
     */
    static withComponents(components, componentInjector = DynamicComponent) {
        return DynamicModule.forRoot(componentInjector);
    }
}
DynamicModule.ɵfac = function DynamicModule_Factory(t) { return new (t || DynamicModule)(); };
DynamicModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DynamicModule });
DynamicModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    DynamicComponent,
                    DynamicDirective,
                    ComponentOutletInjectorDirective,
                    DynamicAttributesDirective,
                    DynamicDirectivesDirective,
                ],
                exports: [
                    DynamicComponent,
                    DynamicDirective,
                    ComponentOutletInjectorDirective,
                    DynamicAttributesDirective,
                    DynamicDirectivesDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DynamicModule, { declarations: function () { return [DynamicComponent, DynamicDirective, ComponentOutletInjectorDirective, DynamicAttributesDirective, DynamicDirectivesDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DynamicComponent, DynamicDirective, ComponentOutletInjectorDirective, DynamicAttributesDirective, DynamicDirectivesDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ng-dynamic-component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { ComponentOutletInjectorDirective, DynamicAttributesDirective, DynamicComponent, DynamicDirective, DynamicDirectivesDirective, DynamicModule, dynamicDirectiveDef, windowRefFactory, COMPONENT_INJECTOR as ɵa, IoService as ɵb, IoFactoryService as ɵc, WINDOW_REF as ɵd, WindowRefService as ɵe };

